/**
 * Debounce:
 * delays the function call until the activity has paused for the given amount of ms,
 * useful when you only need to run the function after finishes input, scrolling, resizing etc.
 *
 * @param func
 * @param delay
 * @returns {(function(...[*]): void)|*}
 */
function debounce(func, delay = 100) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), delay);
    };
}
export default debounce;


// /** Throttle
//  * Limit the frequency of function calls to once every n ms
//  * @param fn
//  * @param delay
//  * @returns {function(...[*]): *}
//  */
// function throttle(fn, delay) {
//     let lastCall = 0;
//     return function (...args) {
//         const now = new Date().getTime();
//         if (now - lastCall < delay) return;
//         lastCall = now;
//         return fn(...args);
//     };
// }
//
// export default {debounce, throttle};
